<template>
  <div>
    <bankUserDialog
      :idProps="dataId"
      :select="select"
      :newUserDialog="dialog"
      @setDialog="dialog = $event"
      @onSaved="deleteBank($event)"
    ></bankUserDialog>
    <bankViewsDialog
      :newUserDialog="dialogViews"
      @setDialog="dialogViews = $event"
      @onSaved="deleteBank($event)"
    ></bankViewsDialog>
    <v-toolbar dense flat>
      <v-layout align-center justify-space-between row fill-height>
        <v-flex xs12 sm5>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search date/ time/ name/ province"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm5>
          <v-select
            v-model="select"
            prepend-icon="search"
            :items="item"
            item-text="title"
            item-value="value"
            label="Select"
            persistent-hint
            single-line
          ></v-select>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="loadingMessage"
      :items="filtercashlist"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{
            pagination.page * pagination.rowsPerPage -
              (pagination.rowsPerPage - props.index - 1)
          }}
        </td>
        <td class="text-xs-center">
          {{ props.item.transaction_partner_province.province_name_th }}
        </td>

        <td class="text-xs-center">
          {{ moment(props.item.create_at).format("YYYY/MM/DD") }}
        </td>
        <td class="text-xs-center">
          {{ moment(props.item.create_at).format("HH:mm:ss") }}
        </td>
        <td class="text-xs-center">
          {{ props.item.transaction_partner_user_partner.user_partner_name }}
        </td>
        <td class="text-xs-center">
          {{ props.item.transaction_partner_we_credit }}
        </td>
        <td
          class="text-xs-center"
          :style="{
            color:
              props.item.transaction_partner_status == 1
                ? '#fbd200'
                : props.item.transaction_partner_status == 2
                ? '#4caf50'
                : props.item.transaction_partner_status == 3
                ? '#fb3200'
                : null,
          }"
        >
          {{
            props.item.transaction_partner_status == 1
              ? "Pending"
              : props.item.transaction_partner_status == 2
              ? "Approve"
              : props.item.transaction_partner_status == 3
              ? "Rejected"
              : null
          }}
        </td>
        <td>
          <v-btn
            icon
            @click="cashApprove(props.item.transaction_partner_id)"
            v-if="props.item.transaction_partner_status == 1"
          >
            <img
              src="@/assets/back-office/icons/approve.svg"
              alt=""
              width="12px"
            />
          </v-btn>
          <v-btn icon disabled v-else>
            <img
              src="@/assets/back-office/icons/approve.svg"
              alt=""
              width="12px"
            />
          </v-btn>
        </td>
        <td>
          <v-btn
            icon
            @click="cashApproveViews(props.item.transaction_partner_id)"
          >
            <v-icon small>remove_red_eye</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data">
        <div v-if="loadingMessage == true">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ "Loading data ..." }}
        </div>
        <div v-else>
          No data available
          <br />
          <v-btn @click="getData()">Reset</v-btn>
        </div>
      </template>
    </v-data-table>
    <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
      <v-icon color="red">close</v-icon>
      {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
      <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import bankUserDialog from "./CashDetailModal.vue";
import bankViewsDialog from "./CashViewsModal.vue";
import moment from "moment";
export default {
  data: () => ({
    dataId: null,
    changingPassword: false,
    deleteDialog: false,
    search: "",
    loadingMessage: "black",
    pagination: {
      rowsPerPage: 10,
    },
    dialog: false,
    dialogViews: false,
    editDialog: false,
    originalUser: null,
    isDeleting: false,
    item: [
      { title: "All", value: 0 },
      { title: "Pending", value: 1 },
      { title: "Approve", value: 2 },
      { title: "Rejected", value: 3 },
    ],
    select: 0,
    headers: [
      {
        text: "No.",
        value: "",
        sortable: false,
        align: "center",
      },
      {
        text: "Province",
        value: "province_name_th",
        sortable: false,
        align: "center",
      },
      {
        text: "Date",
        sortable: false,
        value: "create_at",
        align: "center",
      },
      {
        text: "Time",
        sortable: false,
        value: "create_at",
        align: "center",
      },
      {
        text: "Name",
        value: "user_partner_name",
        sortable: false,
        align: "center",
      },
      {
        text: "Cash",
        value: "transaction_partner_we_credit",
        align: "center",
        sortable: false,
        align: "center",
      },
      {
        text: "Status",
        value: "transaction_partner_status",
        align: "center",
        sortable: false,
        align: "center",
      },
      {
        text: "Approve",
        value: "",
        align: "center",
        sortable: false,
        align: "center",
      },
      {
        text: "Action",
        value: "",
        align: "center",
        sortable: false,
        align: "center",
      },
    ],
    errSnackbar: false,
    snackBarMsg: null,
  }),
  components: {
    bankUserDialog,
    bankViewsDialog,
  },
  computed: {
    ...mapState({
      getcashDetail: (state) => state.cashRequest.cashListData,
    }),
    filtercashlist() {
      return this.getcashDetail.filter(
        (val) =>
          val.transaction_partner_user_partner.user_partner_name.includes(
            this.search
          ) ||
          val.transaction_partner_province.province_name_th.includes(
            this.search
          ) ||
          moment(val.create_at)
            .format("YYYY/MM/DD")
            .includes(this.search) ||
          moment(val.create_at)
            .format("HH:mm:ss")
            .includes(this.search)
      );
    },
  },
  watch: {
    async select() {
      this.loadingMessage = true;
      await this.getDetailCashData(this.select);
      this.loadingMessage = false;
    },
  },
  methods: {
    ...mapActions({
      getDetailCashViews: "cashRequest/getDetailCash",
      getDetailCashData: "cashRequest/fetchcashList",
    }),
    async getData() {
      this.loadingMessage = true;
      await this.getDetailCashData(this.select);
      await this.$store.dispatch("cashRequest/fetchCountRequest");
      this.loadingMessage = false;
    },
    async cashApprove(item) {
      this.dataId = item;
      this.dialog = true;
      this.isLoading = true;
      await this.getDetailCashViews(item);
      this.isLoading = false;
    },
    async cashApproveViews(item) {
      this.dialogViews = true;
      this.isLoading = true;
      await this.getDetailCashViews(item);
      this.isLoading = false;
    },
    async deleteBank(payload) {
      payload.done();
      this.dialog = false;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.body__district::-webkit-scrollbar {
  display: none;
  max-height: 150px;
  overflow: auto;
}
.badge_status--active {
  @include badge_item;

  background: #fbd200 0% 0% no-repeat padding-box;
  height: 26px;
  width: 95px;
}
.badge_status--inactive {
  @include badge_item;
  border-radius: 10px;
  color: white;
  background: #4caf50 0% 0% no-repeat padding-box;
  padding: 5px;
}
.badge_status--reject {
  @include badge_item;

  background: #fb3200 0% 0% no-repeat padding-box;
  height: 26px;
  width: 95px;
}
.badge_status--delete {
  @include badge_item;

  background: #9b9a99 0% 0% no-repeat padding-box;
  height: 26px;
  width: 95px;
}
</style>
